import palette from './palette';

const input = {
  MuiInputBase: {
    styleOverrides: {
      input: {
        textAlign: 'left',
        '::placeholder': {
          color: 'transparent',
        },
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        position: 'relative',
        transform: 'none',
        transition: 'none',
        fontSize: '10px',
        fontWeight: 600,
        marginBottom: 0,
        color: palette.common.white,
        width: 'fit-content',
        lineHeight: '100%',
        top: '11px',
        padding: '1px 4px 0px 4px',
        textTransform: 'uppercase',
        background: palette.common.black,
        '.has-value &': {
          background: palette.grey[200],
          '&.Mui-error': {
            background: palette.red[500],
          },
        },
        '&.Mui-focused': {
          color: palette.common.white,
        },
        '&.Mui-error': {
          color: palette.common.white,
          background: palette.red[500],
        },
        '&.Mui-disabled': {
          color: palette.common.white,
        },
        maxWidth: 'calc(100% - 15px)',
      },
      shrink: {
        transform: 'none',
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        color: palette.common.black,
        background: palette.common.white,
        fontSize: '16px',
        fontWeight: 400,
        '&.MuiInputBase-multiline': {
          padding: '4px 0',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
        },
        '&.Mui-disabled': {
          WebkitTextFillColor: palette.inputs.disabledText,
          '.Mui-disabled': {
            opacity: 1,
            WebkitTextFillColor: palette.inputs.disabledText,
          },
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
        '&.Mui-error .MuiInputBase-input': {
          color: palette.red[500],
        },
        '&.MuiPickersOutlinedInput-notchedOutline legend': {
          width: 0,
        },
      },
      input: {
        padding: '8px 10px',
      },
      notchedOutline: {
        borderWidth: '1px',
        legend: {
          display: 'none',
        },
      },
    },
  },
  MuiTextField: {
    defaultProps: {
      InputLabelProps: { shrink: true },
    },
  },
};
export default input;

// Original keller styles (old)
// TODO: remove these when they are no longer neeeded
//
// import palette from './palette';
//
// const input = {
//   MuiInputBase: {
//     styleOverrides: {
//       input: {
//         '::placeholder': {
//           color: palette.grey[550],
//           opacity: 1,
//         },
//       },
//       multiline: {
//         padding: '60px',
//       },
//     },
//   },
//   MuiInputLabel: {
//     styleOverrides: {
//       root: {
//         position: 'relative',
//         transform: 'none',
//         transition: 'none',
//         fontSize: '11px',
//         fontWeight: 500,
//         marginBottom: '4px',
//         color: palette.common.black,
//         lineHeight: '130%',
//         '&.Mui-focused': {
//           color: palette.common.black,
//         },
//         '&.Mui-error': {
//           color: palette.red[200],
//         },
//         '&.Mui-disabled': {
//           color: palette.common.black,
//         },
//         maxWidth: 'calc(100% - 15px)',
//       },
//       shrink: {
//         transform: 'none',
//       },
//     },
//   },
//   MuiOutlinedInput: {
//     styleOverrides: {
//       root: {
//         borderRadius: '2px',
//         color: palette.common.black,
//         background: palette.common.white,
//         fontSize: '10px',
//         fontWeight: 400,
//         '&.MuiInputBase-multiline': {
//           padding: '4px 0',
//         },
//         '& .MuiOutlinedInput-notchedOutline': {
//           border: '1px solid',
//           borderColor: palette.grey[200],
//           borderRadius: '2px',
//           top: '0px',
//         },
//         '&:hover .MuiOutlinedInput-notchedOutline': {
//         },
//         '&.Mui-disabled': {
//           WebkitTextFillColor: palette.inputs.disabledText,
//           '.Mui-disabled': {
//             opacity: 1,
//             WebkitTextFillColor: palette.inputs.disabledText,
//           },
//           '.MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline': {
//           },
//         },
//         '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//           border: '1px solid',
//           borderColor: palette.common.black,
//         },
//         '&.Mui-error .MuiOutlinedInput-notchedOutline': {
//         },
//         '&.MuiPickersOutlinedInput-notchedOutline legend': {
//           width: 0,
//         },
//       },
//       input: {
//         padding: '8px 10px',
//       },
//       notchedOutline: {
//         borderWidth: '1px',
//         legend: {
//           display: 'none',
//         },
//       },
//     },
//   },
//   MuiTextField: {
//     defaultProps: {
//       InputLabelProps: { shrink: true },
//     },
//     variants: [
//       {
//         props: { size: 'sm' },
//         style: {
//           '& .MuiInputBase-root': {
//             fontSize: '0.875rem',
//             padding: '8px 12px',
//           },
//           '& .MuiInputLabel-root': {
//             fontSize: '0.875rem',
//           },
//         },
//       },
//       {
//         props: { size: 'md' },
//         style: {
//           '& .MuiInputBase-root': {
//             fontSize: '0.975rem',
//             padding: '16px 8px 1px 8px',
//           },
//           '& .MuiInputLabel-root': {
//             fontSize: '0.675rem',
//           },
//         },
//       },
//     ],
//   },
// };
// export default input;
